import { useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSingleRequest from '../useSingleRequest';
import { getRequestViewSections } from '../requestViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const SingleRequest = () => {
  const { t } = useTranslation();
  const { singleItem, loading, titleTypes, statusTexts } = useSingleRequest();

  const sections = useMemo(
    () => getRequestViewSections(t, singleItem, { titleTypes, statusTexts }),
    [t, singleItem, titleTypes, statusTexts],
  );

  const pageTitle =
    titleTypes?.[singleItem?.type_event] ||
    t('APERTURE/CHIUSURE COMMERCIALI');

  const showEdit =
    singleItem?.can_update || singleItem?.can_approve;

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {showEdit && (
            <Col>
              <Button>
                <Link to={`/facility/requests/${singleItem?.id}/edit`}>
                  {t('MODIFICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/facility/requests'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleRequest;
